import { createSlice } from '@reduxjs/toolkit';
import { get_initial_ui_settings } from 'console/redux/settings-actions';
const slice = createSlice({
    name: 'selected_id',
    initialState: () => {
        const { selected_device_id, map_dashboard_active, zth_dashboard_active } = get_initial_ui_settings(window.PRELOAD);
        let selected_device_id_initial = null;
        for (const device of window.PRELOAD.devices) {
            if (device.id === selected_device_id) {
                selected_device_id_initial = selected_device_id;
                break;
            }
        }
        //Если сбились настройки, то возьмём первое устройство
        if (selected_device_id_initial == null) {
            selected_device_id_initial = window.PRELOAD.devices[0]?.id || null;
        }
        //Если выбрана карта устройств или сводка, то не выбрали никакое устройство
        if (map_dashboard_active || zth_dashboard_active) {
            selected_device_id_initial = null;
        }
        return selected_device_id_initial;
    },
    reducers: {
        _pickDevice: (state, action) => action.payload,
    },
});
export const { _pickDevice } = slice.actions;
export const selectedDeviceIdReducer = slice.reducer;
